<template>
  <div v-loading="loading">
    <div class="detail_echart_table">
      <div class="operations-head operations-head-content">{{ $t("Relationship.UBORuler") }}</div>
      <div class="flex-between-center">
        <div class="ruler_top_left">
          <div class="detail_top_item">
            <div class="detail_top_item_title">
              <OverflowTooltip
                :tip="shareholderChartSummaryObject?.ultimateBeneficiary"
                :lineClamp="2"
              />
            </div>
            <div class="detail_top_item_value">{{ $t("Relationship.UItimateBeneficiaryOwner") }}</div>
          </div>
          <div class="detail_top_item">
            <div class="detail_top_item_title">
              {{ shareholderChartSummaryObject?.shareholdingLayers }}
            </div>
            <div class="detail_top_item_value">{{ $t("Relationship.ShareholderLevel") }}</div>
          </div>
          <div class="detail_top_item">
            <div class="detail_top_item_title">
              {{ shareholderChartSummaryObject?.partiesInvolved }}
            </div>
            <div class="detail_top_item_value">{{ $t("Relationship.PartiesInvolved") }}</div>
          </div>
          <div class="detail_top_item">
            <div class="detail_top_item_title">
              {{ shareholderChartSummaryObject?.relatedCompany }}
            </div>
            <div class="detail_top_item_value">{{ $t("Relationship.RelatedCompanies") }}</div>
          </div>
          <div class="detail_top_item">
            <div class="detail_top_item_title">
              {{ shareholderChartSummaryObject?.companyShareholders }}
            </div>
            <div class="detail_top_item_value">{{ $t("Relationship.CompanyShareholders") }}</div>
          </div>
          <div class="detail_top_item">
            <div class="detail_top_item_title">
              {{ shareholderChartSummaryObject?.ngoShareholders }}
            </div>
            <div class="detail_top_item_value">{{ $t("Relationship.NGOShareholders") }}</div>
          </div>
          <div class="detail_top_item">
            <div class="detail_top_item_title">
              {{ shareholderChartSummaryObject?.naturalPersonShareholder }}
            </div>
            <div class="detail_top_item_value">{{ $t("Relationship.NaturalPersonShareholders") }}</div>
          </div>
          <div class="detail_top_item">
            <div class="detail_top_item_title">
              {{ shareholderChartSummaryObject?.subjectInvestments }}
            </div>
            <div class="detail_top_item_value">{{ $t("Relationship.SubjectsInvestments") }}</div>
          </div>
        </div>
        <div class="ruler_box">
          <div class="ruler_slider">
            <DiscreteSlider v-model="percent" @changeRuler="onChangeRuler" />
          </div>
          <!-- <div class="ruler_item">
            <div class="ruler_item_label">Level of shareholder hierarchy:</div>
            <div class="ruler_item_content">
              <el-select
                style="width: 100%"
                clearable
                filterable
                popper-class="new-search-select"
                placeholder=""
                v-model="filterLevel"
                @change="(val) => filterSearch(val)"
              >
                <el-option
                  v-for="(value, key, index) in levelObjs"
                  :key="index"
                  :value="key"
                  :label="key"
                />
              </el-select>
            </div>
          </div> -->
          <div class="ruler_item">
            <div class="ruler_item_label">
              {{ $t("Relationship.Numberofshareholderenterprises") }}:
            </div>
            <div class="ruler_item_content">
              {{ Object.values(levelObjs).reduce((sum, num) => sum + num, 0) }}
            </div>
          </div>
          <div class="ruler_item lines_item">
            <div class="ruler_item_label">{{ $t("Relationship.Thelargestholdingcompany") }}:</div>
            <div
              class="ruler_item_content link_text"
              @click="
                goDetail({ companyName: largeCompany, aaaid: largeCompanyid })
              "
            >
              <OverflowTooltip :tip="largeCompany" :lineClamp="2" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="detail_echart_table">
      <div class="operations-head operations-head-content">
        {{ $t("Relationship.CompanyShareholders") }}
      </div>
      <el-table
        class="risk_table"
        :data="tableData"
        height="100%"
        ref="tableRef"
        row-key="aaaId"
      >
        <el-table-column
          prop="companyName"
          :label="$t('Relationship.CompanyName')"
          min-width="200"
          show-overflow-tooltip
        >
          <template #default="{ row }">
            <!-- <span class="link_hover_text" @click="goDetail(row)">
              {{ row.companyName }}
            </span> -->
            <span
              class="link_hover_text"
              v-if="row.type == 'Company'"
              @click="goDetail(scope.row)"
            >
              {{ row.companyName }}</span
            >
            <span v-else>
              {{ row.companyName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="currentLevel"
          align="center"
          :label="$t('Relationship.CurrentLevel')"
          min-width="100"
        >
          <template v-slot:header>
            <div
              class="table_header_search_title"
              @click="isSearchLevel = false"
              v-if="isSearchLevel"
            >
              {{ $t("Relationship.CurrentLevel") }} <i class="iconfont icon-jiantouxia" />
            </div>
            <el-select
              v-else
              style="width: 100%"
              clearable
              filterable
              class="table_header_search"
              popper-class="new-search-select"
              :placeholder="$t('Relationship.EnterCurrentLevel')"
              v-model="filterName"
              @change="(val) => filterSearch(val)"
            >
              <el-option
                v-for="(value, key, index) in levelObjs"
                :key="index"
                :value="key"
                :label="key"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          prop="holdingRatioDesc"
          :label="$t('Relationship.SharesonSubjectCo')"
          align="center"
          min-width="145"
        >
        </el-table-column>
        <el-table-column
          prop="country"
          align="center"
          :label="$t('Relationship.Country')"
          min-width="120"
        >
        </el-table-column>
      </el-table>
    </div>

    <Tips :dialogVisible.sync="isShowTips"></Tips>
  </div>
</template>
<script>
import { mixins1 } from "@/mixins/index";
import Page from "@/views/newLayout/page.vue";
import Tips from "@/views/newLayout/tips.vue";
import DiscreteSlider from "./Com_DiscreteSlider.vue";
import { getShareholderDeepList } from "@/api/uboApi";
import { getShareholderChartSummary } from "@/api/companyApi";
export default {
  name: "UboDetail7",
  mixins: [mixins1],
  components: {
    Page,
    Tips,
    DiscreteSlider,
  },
  data() {
    return {
      percent: 50, //刻度百分比
      loading: false,
      isShowTips: false,
      filterLevel: "",
      total: 0,
      params: {
        aaaid: this.$route.query.id3a,
        holdingRatio: "",
        currentLevel: "",
      },
      shareholderChartSummaryObject: {},
      levelObjs: {},
      largeCompany: "",
      searchParams: {
        currentPage: 1,
        pageSize: 10,
      },
      tableData: [],
      localTableData: [],
      isSearchLevel: true,
      filterName: "",
    };
  },
  methods: {
    onChangePage(param) {},
    // 跳转ubo详细
    goDetail(row) {
      let routeData = this.$router.resolve({
        path: "/ubo/detail",
        query: {
          id3a: row.aaaid,
          keyword: row.companyName,
          selectKey: "Company",
        },
      });
      window.open(routeData.href, "_blank");
    },
    // 滑动标尺
    onChangeRuler(val) {
      // this.filterLevel = "";
      if (val == 0) {
        this.tableData = [];
      }
      this.params.holdingRatio = val;
      this.getShareholderDeepListApi();
    },
    // 选择level
    filterSearch(val) {
      // this.params.currentLevel = val;
      // this.getShareholderDeepListApi();
      if (val) {
        this.tableData = this.localTableData.filter(
          (list) => list.currentLevel == val,
        );
      } else {
        this.tableData = this.localTableData;
      }
    },
    // 初始化
    async getShareholderDeepListApi() {
      this.loading = true;
      this.tableData = [];
      this.levelObjs = {};
      this.largeCompany = "";
      let res = await getShareholderDeepList(this.params);
      if (res) {
        this.levelObjs = res.data.map;
        this.largeCompany = res.data.largestHoldingCompany;
        this.largeCompanyid = res.data.aaaid;
        // if (this.filterLevel != "") {
        this.tableData = Object.freeze(res.data.shareholderDeepVOList);
        this.localTableData = Object.freeze(res.data.shareholderDeepVOList);
        // }

        this.loading = false;
      }
    },
    getShareholderChartSummaryList() {
      getShareholderChartSummary({
        id3a: this.$route.query.id3a,
      }).then((res) => {
        if (res.code == 200) {
          this.shareholderChartSummaryObject = res.data;
        }
      });
    },
  },
  mounted() {
    this.getShareholderChartSummaryList();
    // this.getShareholderDeepListApi();
  },
};
</script>
<style scoped>
.ruler_top_left {
  display: flex;
  flex-wrap: wrap;
  flex: 1;
  gap: 20px 16px;
}
.detail_top_item {
  width: calc(25% - 12px);
  height: 130px;
  background: #faefec;
  border-radius: 10px;
}
.detail_top_item .detail_top_item_value {
  line-height: 24px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.ruler_box {
  margin-left: 42px;
  width: 510px;
  height: 290px;
  background: #f5f5f5;
  border-radius: 10px;
  flex-shrink: 0;
  padding: 0px 20px 20px 20px;
}
.ruler_slider {
  width: 100%;
  height: 110px;
}
.ruler_item + .ruler_item {
  margin-top: 10px;
}
.ruler_item {
  width: 100%;
  height: 44px;
  background: #ffffff;
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 7px 10px;
}
.ruler_item.lines_item {
  height: auto;
  flex-direction: column;
  align-items: flex-start;
}
.ruler_item_label {
  flex-shrink: 0;
  font-size: 18px;
  color: #1a2332;
  line-height: 24px;
  text-align: left;
  font-style: normal;
}
.ruler_item_content {
  flex: 1;
  font-size: 18px;
  color: #1a2332;
  line-height: 24px;
  text-align: left;
  font-style: normal;
  overflow: hidden;
}
.link_text {
  color: #b44818;
  cursor: pointer;
}
.ruler_item_content >>> .el-input__inner {
  height: 32px;
  background: #ffffff;
  border-radius: 6px;
  border: 1px solid #cccccc;
  box-sizing: border-box;
}
.risk_table {
  min-height: 360px;
}
.risk_table >>> .el-table__empty-block {
  margin-top: 40px;
  background: url("../../assets/images/ruler_empty_bg.png") no-repeat;
  background-size: auto 82%;
  background-position: center center;
}
.risk_table >>> .el-table__empty-block .el-table__empty-text {
  opacity: 0;
}
.detail_top_item_title {
  font-size: 24px;
  line-height: 24px;
}
.detail_top_item_value {
  font-size: 18px;
  line-height: 20px;
}
.table_header_search_title {
  cursor: pointer;
  padding-left: 9px;
  padding-right: 9px;
  font-family: "Arial Bold";
  font-size: 18px !important;
  color: #1a2332;
  line-height: 24px;
  font-style: normal;
}
.table_header_search_title i {
  color: #b44818;
}

@media (max-width: 1920px) {
  .ruler_top_left {
    gap: 16px 14px;
  }
  .detail_top_item {
    width: calc(25% - 11px);
    height: 110px;
    border-radius: 8px;
  }
  .detail_top_item .detail_top_item_value {
    line-height: 20px;
  }
  .ruler_box {
    margin-left: 30px;
    width: 400px;
    height: 250px;
    border-radius: 8px;
    padding: 0px 16px 16px 16px;
  }
  .ruler_slider {
    width: 100%;
    height: 110px;
  }
  .ruler_item {
    height: 34px;
  }
  .ruler_item + .ruler_item {
    margin-top: 8px;
  }
  .ruler_item {
    height: 34px;
    gap: 8px;
    padding: 6px 8px;
  }
  .ruler_item_label {
    font-size: 16px;
    line-height: 20px;
  }
  .ruler_item_content {
    font-size: 16px;
    line-height: 20px;
  }
  .ruler_item_content >>> .el-input__inner {
    height: 28px;
  }
  .risk_table {
    min-height: 300px;
  }
  .risk_table >>> .el-table__empty-block {
    margin-top: 20px;
    background-size: auto 82%;
    background-position: center center;
  }
  .detail_top_item_title {
    font-size: 18px;
    line-height: 20px;
  }
  .detail_top_item_value {
    font-size: 14px;
    line-height: 16px;
  }
  .table_header_search_title {
    padding-left: 7px;
    padding-right: 7px;
    font-size: 16px !important;
    line-height: 20px;
  }
  .table_header_search ::v-deep .el-input--suffix {
    height: 36px;
  }
}
</style>
